import { __assign } from '../../external/tslib/tslib.es6.mjs.js';
import { jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { Item } from './item/Item.js';
import styles from './RadioGroup.module.scss.js';

var RadioGroup = function (_a) {
    var children = _a.children, ariaLabelledby = _a["aria-labelledby"], className = _a.className, style = _a.style;
    return (jsx("fieldset", __assign({ "aria-labelledby": ariaLabelledby, className: clsx(styles.radioGroup, className), style: style }, { children: children })));
};
RadioGroup.Item = Item;

export { RadioGroup };
